(function () {
  function enforceMOQ() {
    document.querySelectorAll('[data-line-item]').forEach(function (item) {
      const moqAttr = item.querySelector('[data-line-item-property="_ostori_moq"]');
      if (!moqAttr) return;

      const moq = parseInt(moqAttr.textContent, 10);
      if (!moq || moq < 1) return;

      const input = item.querySelector('input[name="updates[]"]');
      const minus = item.querySelector('button[name="minus"]');

      if (!input) return;

      let val = parseInt(input.value, 10) || moq;
      if (val < moq) {
        input.value = moq;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        val = moq;
      }

      if (minus) {
        minus.disabled = val <= moq;
      }
    });
  }

  document.addEventListener('cart:updated', enforceMOQ);
  document.addEventListener('cart:refresh', enforceMOQ);
  document.addEventListener('quick-cart:open', enforceMOQ);

  new MutationObserver(enforceMOQ).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
